import * as React from 'react';
import { InjectedRouter } from 'react-router';
import ToastActions from 'actions/ToastActions';
import { withRouter } from 'app/context/Router';
import LinkConstants from 'constants/LinkConstants';
import { mergingUserPoll } from 'user/utils/mergingUserPoll';
import MergingUserPoller from 'user/components/MergingUserPoller';

import { dispatcher } from 'lib/Dispatcher';
// @ts-ignore
import { ActionTypes } from 'user/UserConstants';
// @ts-ignore
import AuthActions from 'auth/AuthActions';
import { ClaimDevice_claimDevice } from 'user/mutations/__generated__/ClaimDevice';

export type Props = {
  router: InjectedRouter;
  location?: {
    state?: {
      claimedDevice?: ClaimDevice_claimDevice;
    };
  };
};

export class MergingUserContainer extends React.Component<Props, {}> {
  obsoleteCurrentUser = async () => {
    await AuthActions.signoutWithoutRedirect();

    dispatcher.dispatch({ type: ActionTypes.USER_DELETED });
  };

  async componentDidMount() {
    const { statusEndpoint, reauthenticationToken } =
      this.props.location?.state?.claimedDevice ?? {};

    if (!statusEndpoint) {
      return this.props.router.replace(LinkConstants.MERGING_USER_COMPLETE);
    }

    try {
      if (reauthenticationToken) {
        await this.obsoleteCurrentUser();
        await AuthActions.accessTokenSignIn(reauthenticationToken);
      }

      await mergingUserPoll(`/${statusEndpoint}`);

      ToastActions.showSuccessToast('Your accounts have been merged.');
    } catch (error) {
      const message = error?.message ?? 'Unable to merge accounts. Please contact support.';

      ToastActions.showErrorToast(message);
    }

    this.props.router.replace(LinkConstants.MERGING_USER_COMPLETE);
  }

  render() {
    return <MergingUserPoller />;
  }
}

export default withRouter(MergingUserContainer);
